// src/stores/serviceStore.js
import { defineStore } from "pinia";
import { serviceService } from "@/services/serviceService";
import { useAppStore } from "@/stores/appStore";
import { toast } from 'vue3-toastify';

export const useServiceStore = defineStore("serviceStore", {
  state: () => ({
    services: [],
    service: [],
  }),

  actions: {
    async getAllServices() {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await serviceService.fetchAllServices();
        this.services = response.data;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2001');
      } finally {
        appStore.setLoading(false);
      }
    },

    async getService(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await serviceService.fetchService(id);
        this.service = response.data;
        return this.service;
      } catch (error) {
        toast.error(error.response.data.message + ' - 2002');
      } finally {
        appStore.setLoading(false);
      }
    },

    async createservice(userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await serviceService.fetchCreateService(userData);
        this.services.push(response.data);
      } finally {
        appStore.setLoading(false);
      }
    },

    async updateservice(id, userData) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        const response = await serviceService.fetchUpdateService(id, userData);
        const index = this.services.findIndex(b => b.id === id);
        if (index !== -1) {
          this.services.splice(index, 1, response.data);
        }
      } finally {
        appStore.setLoading(false);
      }
    },

    async deleteservice(id) {
      const appStore = useAppStore();
      appStore.setLoading(true);

      try {
        await serviceervice.fetchDeleteService(id);
        this.services = this.services.filter(b => b.id !== id);
        toast.success("Success");
      } catch (error) {
        toast.error(error.response.data.message + ' - 2003');
      } finally {
        appStore.setLoading(false);
      }
    },
  },
});
